/**
 * Clock Widget
 *
 * Displays current date, time, and week number.
 * Updates every second.
 *
 * @author BizClick WMS
 * @version 1.0.0
 */

import React, { useState, useEffect } from 'react';
import { Calendar, Clock } from 'lucide-react';
import { WidgetInstance } from '../../types';
import { getCurrentDateTime } from '../../mockDataService';
import WidgetWrapper from '../WidgetWrapper';

interface ClockWidgetProps {
  instance: WidgetInstance;
}

const ClockWidget: React.FC<ClockWidgetProps> = ({ instance }) => {
  const [dateTime, setDateTime] = useState(getCurrentDateTime());

  useEffect(() => {
    const timer = setInterval(() => {
      setDateTime(getCurrentDateTime());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <WidgetWrapper instance={instance}>
      <div className="h-full flex flex-col items-center justify-center text-center">
        <div className="text-4xl font-bold text-white font-mono tracking-wider">
          {dateTime.time}
        </div>
        <div className="mt-2 text-sm text-gray-400 capitalize">
          {dateTime.date}
        </div>
        <div className="mt-1 text-xs text-blue-400 font-medium">
          {dateTime.week}
        </div>
      </div>
    </WidgetWrapper>
  );
};

export default ClockWidget;
